
export abstract class MediaManagerService {

    protected localStream: MediaStream = new MediaStream();
    protected remoteStream: MediaStream = new MediaStream();

    abstract addLocalTrack(track: MediaStreamTrack): void;
    abstract removeLocalTrack(track: MediaStreamTrack): void;
    abstract addRemoteTrack(track: MediaStream | MediaStreamTrack): void;
    abstract removeRemoteTrack(track: MediaStreamTrack): void;
    abstract setRemoteMediaStream(mediaStream: MediaStream): void;
    abstract setLocalMediaStream(mediaStream: MediaStream): void;
}